import BaseApiService from '../baseApi.service';

export default class MembershipTicketService extends BaseApiService {
  readonly basePath: string = 'membershipTickets/v1';
  constructor(props = null) {
    super(props);
  }
}
